import { jsx } from "react/jsx-runtime";
import "react";
const SvgApple = (props)=>/*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 21,
        fill: "none",
        viewBox: "0 0 20 21",
        ...props,
        children: /*#__PURE__*/ jsx("path", {
            fill: "#2B2B2B",
            d: "M10.092 5.52c.907 0 2.045-.61 2.723-1.424.613-.738 1.06-1.768 1.06-2.798 0-.14-.012-.28-.038-.394-1.01.038-2.224.674-2.953 1.526-.575.648-1.1 1.666-1.1 2.708 0 .153.026.305.04.356.063.013.165.026.268.026M6.896 20.904c1.24 0 1.79-.826 3.336-.826 1.573 0 1.918.8 3.299.8 1.355 0 2.262-1.245 3.119-2.466.959-1.398 1.355-2.771 1.38-2.835-.089-.025-2.684-1.08-2.684-4.043 0-2.569 2.045-3.726 2.16-3.815-1.355-1.932-3.413-1.983-3.975-1.983-1.522 0-2.762.915-3.542.915-.843 0-1.956-.864-3.272-.864-2.506 0-5.05 2.06-5.05 5.95 0 2.416.946 4.972 2.11 6.624.997 1.399 1.866 2.543 3.119 2.543"
        })
    });
const apple = SvgApple;
export { apple as default };
